export const SET_ENV_DOMAIN= 'SET_ENV_DOMAIN';
export const SET_USER_TRACKING_ID= 'SET_USER_TRACKING_ID';